







































































































































































































import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
import FileSaver from 'file-saver'
import { useAgrupamento } from '@/composables'
import useScrollArrowsTabela from '@/composables/useScrollArrowsTabela/useScrollArrowsTabela'
import { MoverItemAgrupamentoSelecao } from '@/types/interfaces/MoverItemAgrupamento'
import RemuneracaoMedicaApi from '@/Apis/RemuneracaoMedica/Services/RemuneracaoMedicaApi'
import EventBus from '@/plugins/EventBus'

@Component
export default class FinanceiroAgrupamentos extends Vue {
  filtrosDefault = {
    fontePagadoraId: null,
    anoMesReferencia: null,
    repassesQueSolicitamNF: null,
    periodoCriacaoInicio: null,
    periodoCriacaoFim: null,
    numeroChamado: null,
  }

  filtros: any = { ...this.filtrosDefault }

  filterDrawer = false
  menuMesReferencia = false
  menuPeriodoInicio = false
  menuPeriodoFim = false

  rpaOpcoes = [
    { text: 'RPA (não solicita NF)', value: false },
    { text: 'Não RPA (solicita NF)', value: true },
  ]

  itens: any[] = []
  totalRegistros = 0
  pagina = 1
  qtdPorPagina = 50
  loading = false
  pesquisado = false

  downloadingId: string | null = null

  modalDetalhes = false
  agrupamentoIdSelecionado: string | null = null

  modalEditarChamado = false
  itemParaEditarChamado: any = null

  modalCriarAgrupamento = false

  modalMoverItem = false
  moverItem: MoverItemAgrupamentoSelecao = { repasse: null, agrupamento: null }

  scrollArrows = useScrollArrowsTabela(refName => this.getTabelaOverflow(refName))

  headers = [
    { text: 'Fonte pagadora', value: 'fontePagadoraNome', align: 'left', sortable: false },
    { text: 'Nº chamado', value: 'numeroChamado', align: 'center', sortable: false },
    { text: 'Mês ref.', value: 'anoMesReferencia', align: 'center', sortable: false },
    { text: 'Qtd repasses', value: 'quantidadeRepasses', align: 'center', sortable: false },
    { text: 'Valor total', value: 'valorTotalAgrupado', align: 'center', sortable: false },
    { text: 'Criado por', value: 'criadoPorNome', align: 'center', sortable: false },
    { text: 'Criado em', value: 'createdOn', align: 'center', sortable: false },
    { text: 'Última alt.', value: 'ultimaAlteracaoChamadoEm', align: 'center', sortable: false },
    { text: 'RPA', value: 'repassesQueSolicitamNF', align: 'center', sortable: false },
    { text: 'Ações', value: 'acoes', align: 'center', sortable: false },
  ]

  get anoMesReferenciaFormatado() {
    if (!this.filtros.anoMesReferencia) return ''
    return moment(this.filtros.anoMesReferencia, 'YYYY-MM').format('MM/YYYY')
  }

  get fontesPagadoras() {
    return useAgrupamento.fontesPagadoras
  }

  get arrowsState() {
    return this.scrollArrows.setas
  }

  get paginas() {
    return Math.ceil(this.totalRegistros / this.qtdPorPagina)
  }

  get qtdFiltrosAtivos() {
    return Object.keys(this.filtrosDefault).filter((chave) => {
      const valor = (this.filtros as any)[chave]
      return valor !== null && valor !== undefined && valor !== ''
    }).length
  }

  toggleFiltros() {
    this.filterDrawer = !this.filterDrawer
  }

  formatarData(value: string | null) {
    if (!value) return ''
    return moment(value).format('DD/MM/YYYY')
  }

  formatarDataHora(value: string | null) {
    if (!value) return ''
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  formatarMesAno(value: string | null) {
    if (!value) return '-'
    return moment(value).format('MM/YYYY')
  }

  rotuloRpa(value: boolean | null | undefined) {
    if (value === null || value === undefined) return '-'
    return value ? 'Não' : 'Sim'
  }

  corRpaClass(value: boolean | null | undefined) {
    return value ? 'chip-rpa--nao-rpa' : 'chip-rpa--rpa'
  }

  onChangePagina(novaPagina: number) {
    this.pagina = novaPagina
    this.buscar()
  }

  async pesquisar() {
    this.pagina = 1
    this.filterDrawer = false
    await this.buscar()
  }

  async limparFiltros() {
    this.filtros = { ...this.filtrosDefault }
    this.pagina = 1
    await this.buscar()
  }

  async buscar() {
    this.loading = true
    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
      }
      if (this.filtros.fontePagadoraId) params.fontePagadoraId = this.filtros.fontePagadoraId
      if (this.filtros.anoMesReferencia) {
        // toISOString() converteria pro horário UTC (deslocando algumas horas do valor
        // original), e o backend compara AnoMesReferencia por igualdade exata, teria
        // que bater com o mesmo instante "sem fuso" que ele mandou.
        params.anoMesReferencia = moment(this.filtros.anoMesReferencia, 'YYYY-MM').startOf('month').format('YYYY-MM-DD[T]HH:mm:ss')
      }
      if (this.filtros.repassesQueSolicitamNF !== null && this.filtros.repassesQueSolicitamNF !== undefined) {
        params.repassesQueSolicitamNF = this.filtros.repassesQueSolicitamNF
      }
      if (this.filtros.periodoCriacaoInicio) params.periodoCriacaoInicio = this.filtros.periodoCriacaoInicio
      if (this.filtros.periodoCriacaoFim) params.periodoCriacaoFim = this.filtros.periodoCriacaoFim
      if (this.filtros.numeroChamado) params.numeroChamado = this.filtros.numeroChamado

      const response: any = await RemuneracaoMedicaApi.getAgrupamentos(params)
      if (response.success) {
        this.itens = response.data.itens || []
        this.totalRegistros = response.data.totalRegistros || 0
        this.pesquisado = true
        this.$nextTick(() => this.scrollArrows.anexar('tabelaLista'))
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao carregar agrupamentos.', icon: 'warning', color: '#C62828' })
      }
    } finally {
      this.loading = false
    }
  }

  getTabelaOverflow(refName: string): HTMLElement | null {
    const tabela = this.$refs[refName] as Vue | undefined
    return tabela ? (tabela.$el as HTMLElement).querySelector('.v-table__overflow') : null
  }

  scrollTable(refName: string, delta: number) {
    this.scrollArrows.rolar(refName, delta)
  }

  beforeDestroy() {
    this.scrollArrows.destruir()
  }

  abrirDetalhes(item: any) {
    this.agrupamentoIdSelecionado = item.id
    this.modalDetalhes = true
  }

  abrirEditarChamado(item: any) {
    this.itemParaEditarChamado = item
    this.modalEditarChamado = true
  }

  abrirCriarAgrupamento() {
    this.modalCriarAgrupamento = true
  }

  abrirMoverItem(payload: MoverItemAgrupamentoSelecao) {
    this.moverItem = payload
    this.modalMoverItem = true
  }

  async onItemMovido() {
    const modalDetalhe = this.$refs.modalDetalhe as any
    await Promise.all([this.buscar(), modalDetalhe && modalDetalhe.carregarDetalhe()])
  }

  getTooltipBaixarPdf(item: { quantidadeRepasses: number }) {
    if (item.quantidadeRepasses === 0) {
      return 'Agrupamento sem repasses vinculados'
    }

    return 'Baixar PDF de notas fiscais'
  }

  async baixarPdf(item: any) {
    this.downloadingId = item.id
    try {
      const response: any = await RemuneracaoMedicaApi.downloadAgrupamento({ id: item.id })
      if (response.success) {
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const identificador = item.numeroChamado || item.id.substring(0, 8)
        FileSaver.saveAs(blob, `Agrupamento-${identificador}-${moment(item.createdOn).format('DDMMYYYY')}.pdf`)
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível baixar o arquivo.', icon: 'warning', color: '#C62828' })
      }
    } catch {
      EventBus.$emit('setSnackbar', { show: true, text: 'Arquivo não encontrado ou expirado.', icon: 'warning', color: '#C62828' })
    } finally {
      this.downloadingId = null
    }
  }

  async created() {
    await Promise.all([
      useAgrupamento.loadFontesPagadoras({ showToastError: true }),
      this.buscar(),
    ])
  }
}
